import React, { FunctionComponent } from 'react';
import DesignText from '@/components/typography/DesignText';
import WeatherIcon from '@/components/weather/WeatherIcon';
import moment from 'moment-timezone';
import styles from './DayForecastItem.module.scss';

interface IProps {
  time: number; // Will need to massage into a display date
  summary: string; // Also known as conditions
  icon: string; // Could re-map using weather_blurb_from_forecast_io_map
  temperatureHigh: number; // should round to 0
  temperatureLow: number; // should round to 0
}

const DayForecastItem: FunctionComponent<IProps> = ({ time, summary, icon, temperatureHigh, temperatureLow }) => {
  const displayDay = moment(time * 1000).format('ddd');
  const displayHighTemperature = Math.round(temperatureHigh);
  const displayLowTemperature = Math.round(temperatureLow);
  const temperatureDisplay = `Hi ${displayHighTemperature}° / Lo ${displayLowTemperature}°`;
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <WeatherIcon openWeatherIconName={icon} />
      </div>
      <div className={styles.dayText}>{displayDay}</div>
      <div className={styles.temperatureText}>{temperatureDisplay}</div>
      <DesignText thin color="white" className={styles.summaryText}>
        {summary}
      </DesignText>
    </div>
  );
};

export default DayForecastItem;
